import { batyaQuest } from './Batya';
import { unheardQuest } from './Unheard';
import { tourQuest } from './Tour';
import { witnessQuest } from './AccidentalWitness';
import { fallingSkiesQuest } from './FallingSkies';
import { labyrinthQuest } from './Labyrinth';
import { alreadyHereQuest } from './TheyAreAlreadyHere';
import { blueFlameQuest } from './BlueFlame';
import { ticketQuest } from './TheTicket';

export const STORY_DATA = [
  batyaQuest,
  unheardQuest,
  ticketQuest,
  tourQuest,
  witnessQuest,
  fallingSkiesQuest,
  labyrinthQuest,
  alreadyHereQuest,
  blueFlameQuest
];